
import { useEffect, useRef } from "react";
import { Box } from "@mui/material";

function titleCase(str) {
    if ((str === null) || (str === ''))
        return false;
    else
        str = str.toString();

    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() +
            txt.substr(1).toLowerCase();
    });
}

export default function VideoPlayer({ mpdurl, textTrackCallback }) {
    const videoRef = useRef(null);
    const subdivRef = useRef(null);
    const observerRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        if (!videoRef.current || !mpdurl) return;

        if(subdivRef.current){
            subdivRef.current.textContent = ''
        }

        const dashjs = window.dashjs;

        const player = dashjs.MediaPlayer().create();
        playerRef.current = player;

        player.updateSettings({
            debug: { logLevel: 3 },
            streaming: {
                // buffer: {
                //     bufferTimeAtTopQuality: 25,
                //     bufferTimeAtTopQualityLongForm: 40,
                //     bufferTimeDefault: 12,
                //     longFormContentDurationThreshold: 300,
                //     fastSwitchEnabled: true,
                // },
                text: {
                    webvtt: { customRenderingEnabled: true },
                },
            },
        });

        player.initialize(videoRef.current, mpdurl, true);

        /* ---------- Attach Custom Subtitle Container ---------- */
        player.attachVttRenderingDiv(subdivRef.current);

        /* ---------- JSON → HTML Converter ---------- */
        const modifySubtitleText = (jsonText) => {
            console.log(jsonText);
            try {
                const obj = JSON.parse(jsonText);

                return ['lat', 'lon', 'speed' ,'ist_timestamp'].map( (key) =>
                    `<div class="json-item">
                            <span class="json-key">${titleCase(key)}: </span>
                            <span class="json-val">${obj[key].toString().toUpperCase()}</span>
                        </div>`
                ).join("");

             
                    
            } catch {
                return jsonText; // fallback: show raw
            }
        };

        /* ---------- Mutation Observer ---------- */
        observerRef.current = new MutationObserver((mutations) => {
            const last = mutations[mutations.length - 1];
            const el = last?.target;
            if (!el) return;

            var text = el.textContent?.trim();
            if (!text) return;

            // callback to parent
            try {
                textTrackCallback?.(text);
            } catch { }

            const html = modifySubtitleText(text);

            observerRef.current.disconnect();
            subdivRef.current.innerHTML = html;
            observerRef.current.observe(subdivRef.current, {
                childList: true,
                subtree: true,
            });
        });

        observerRef.current.observe(subdivRef.current, {
            childList: true,
            subtree: true,
        });

        return () => {
            observerRef.current?.disconnect();
            playerRef.current?.reset();
            playerRef.current = null;
        };
    }, [mpdurl]);

    return (
        <Box
            sx={{
                position: "relative",
                flex: 1,
                width: "100%",
                overflow: "hidden"  // IMPORTANT: prevents video control overflow
            }}
        >
            {/* Video */}
            <Box
                ref={videoRef}
                component="video"
                controls
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    backgroundColor : "rgb(0, 0, 0)",
                    display: "block" 
                }}
            >
            </Box>

            {/* Overlay */}
            
                <Box
                    ref={subdivRef}
                    sx={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        border: '1px solid',
                        backgroundColor: "rgb(39, 39, 39)",
                        color: "white",
                        px: 1,
                        py: 1,
                        borderRadius: 1,
                        zIndex: 10,
                        pointerEvents: "none",
                        
                    }}
                >
                    {/* Content goes here */}
                </Box>
          
        </Box>
    );
}

